import i18nInst from 'src/i18n';
import { PolicyApi } from '@Apis';
import {
  BuildingBlock,
  BuildingBlockTypeEnum,
  DlpExpression,
  DlpKeyword,
  // DlpOperatorEnum,
} from 'src/pages/Policy/utils/types';
import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
export interface DlpTemplateDetailState {
  keywordList: DlpKeyword[];
  expressionList: DlpExpression[];
  buildingBlockList: BuildingBlock[];
}
export interface DlpTemplateDetailAction {
  addBuildingBlock: (value: BuildingBlock) => void;
  deleteLastBuildingBlock: () => void;
  deleteSpecificBuildingBlock: (index: number) => void;
  getKeyWordList: () => void;
  getExpressionList: () => void;
  setBuildingBlock: (index: number, payload: Partial<BuildingBlock>) => void;
  addNewBuildingBlock: () => void;
  clearBuildingBlock: () => void;
}
export const useDlpTemplateDetailStore = create(
  immer<DlpTemplateDetailState & DlpTemplateDetailAction>((set, get) => ({
    keywordList: [],
    expressionList: [],
    buildingBlockList: [],
    addBuildingBlock: (value: BuildingBlock) => {
      // Todo: check duplicate
      set((state) => {
        state.buildingBlockList.push(value);
      });
    },
    clearBuildingBlock: () => {
      const store = get();
      const expressionList = store.expressionList;
      const firstExpression = expressionList[0];
      set((state) => {
        // clear building block, then init with the first expression
        state.buildingBlockList = [
          {
            sourceName: firstExpression.dpExpressionInternalname,
            sourceType: BuildingBlockTypeEnum.entity,
            displayName: firstExpression.dpExpressionName,
            entityHits: 1,
          },
        ];
      });
    },
    deleteLastBuildingBlock: () => {
      const store = get();
      const { buildingBlockList } = store;
      if (buildingBlockList.length <= 1) {
        return;
      }
      set((state) => {
        state.buildingBlockList.pop();
      });
    },
    deleteSpecificBuildingBlock: (index: number) => {
      if (index === 0) {
        return;
      }
      console.log(typeof index);
      const store = get();
      const { buildingBlockList } = store;
      const copyBuildingBlockList = [...buildingBlockList];
      copyBuildingBlockList.splice(index, 1);
      set((state) => {
        state.buildingBlockList = copyBuildingBlockList;
      });
    },
    getExpressionList: async () => {
      const { t } = i18nInst;
      try {
        const resp = await PolicyApi.getDlpExpressions(i18nInst.language);
        const { data: expressionList } = resp;
        set((state) => {
          state.expressionList = expressionList;
          if (expressionList.length > 0) {
            const firstExpression = expressionList[0];
            state.buildingBlockList = [
              {
                sourceName: firstExpression.dpExpressionInternalname,
                sourceType: BuildingBlockTypeEnum.entity,
                displayName: firstExpression.dpExpressionName,
                entityHits: 1,
              },
            ];
          } else {
            state.buildingBlockList = [];
          }
        });
      } catch (error) {
        window.showNotification({
          titleMsg: t('common.apiException.internalError'),
          severity: 'error',
        });
        console.error(error);
      }
    },
    getKeyWordList: async () => {
      const { t } = i18nInst;
      try {
        const resp = await PolicyApi.getDlpKeywords(i18nInst.language);
        const { data: keywordList } = resp;
        set((state) => {
          state.keywordList = keywordList;
        });
      } catch (error) {
        window.showNotification({
          titleMsg: t('common.apiException.internalError'),
          severity: 'error',
        });
        console.error(error);
      }
    },
    setBuildingBlock: (index: number, payload: Partial<BuildingBlock>) => {
      const store = get();
      const buildingBlockList = store.buildingBlockList;
      if (index >= buildingBlockList.length) {
        return;
      }
      const newBuildingBlockList = [...buildingBlockList];
      newBuildingBlockList[index] = {
        ...newBuildingBlockList[index],
        ...payload,
      };
      set((state) => {
        state.buildingBlockList = newBuildingBlockList;
      });
    },
    addNewBuildingBlock: () => {
      const store = get();
      const { expressionList, keywordList } = store;
      const firstExpression = expressionList[0];
      const firstKeyword = keywordList[0];
      if (firstExpression) {
        store.addBuildingBlock({
          sourceName: firstExpression.dpExpressionInternalname,
          sourceType: BuildingBlockTypeEnum.entity,
          displayName: firstExpression.dpExpressionName,
          entityHits: 1,
          // operation: DlpOperatorEnum.and,
        });
      } else if (firstKeyword) {
        store.addBuildingBlock({
          sourceName: firstKeyword.dpKeywordInternalname,
          sourceType: BuildingBlockTypeEnum.keyword,
          displayName: firstKeyword.dpKeywordName,
          // operation: DlpOperatorEnum.and,
        });
      }
    },
  }))
);
